import { Box, Chip, Typography } from "@mui/material"
import React from "react"

import type { Location } from "@/graphql/codegen/graphql"

interface PaymentTypeCardDetailsProps {
  title?: string | null
  subtitle?: string | null
  billingLocations?: (Location | null)[] | null
}

const PaymentTypeCardDetails: React.FC<PaymentTypeCardDetailsProps> = ({ title, subtitle, billingLocations }) => {
  return (
    <Box className='flex'>
      <Box className='flex w-full justify-between'>
        <Box className='flex flex-1 flex-row'>
          <Box className='space-y-1'>
            <Typography className='text-sm font-bold'>{title ?? "-"}</Typography>
            <Typography className='text-sm font-medium'>{subtitle ?? ""}</Typography>
          </Box>
        </Box>
        <Box className='flex-1 flex-col space-y-1'>
          <Typography className='text-sm font-medium'>Associated Company Billing Location</Typography>
          {billingLocations?.map((billingLocation, index) => (
            <Chip
              key={billingLocation?.locationId || index}
              label={billingLocation?.description || "Location"}
              variant='filled'
              size='small'
              className='rounded-[4px] bg-primary-200 text-xs hover:bg-primary-300'
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentTypeCardDetails
